module.exports = __webpack_public_path__ + "img/past-events_olympics.03068962.jpg";